import React, { useState, useEffect } from "react";
import { Table, Input } from "reactstrap";
import CircularProgress from "../../../CircularProgress/CircularProgress";
import style from "./Grid.module.scss";
import * as ItemUI from "./../../../../components/Custody/Items";
import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";
import { Numeric } from "../../Order/Field/Field";
import Account from "../Items/Account";
import { Button } from "reactstrap";
import translate from "../../../../utils/Translator";

const Grid = ({
  custody,
  propia,
  readOnly,
  addCustody,
  removeCustody,
  actions,
  fetchs,
  fetchSearchAccount,
  onChange,
  isFundsXSystem = false,
}) => {
  let debit = 0;
  if (custody !== undefined && custody.length !== 0) {
    if (!readOnly) debit = custody[0].Coldebit + 1;
    else debit = custody[0].Coldebit;
  }

  const custodyObj = custody[0];

  const isCashCustodianDifferent =
    custodyObj &&
    custodyObj.EventCashCustAccountId != 0 &&
    custodyObj.EventCashCustAccountId != custodyObj.BasicAccountId;

  return (
    <div className={`content ${style.desk}`}>
      {!readOnly && (
        <Button
          outline
          color="primary"
          size="sm"
          onClick={() => addCustody(custody, propia, "Custody")}
          className={style.iconBtn}
        >
          <i className="fa fa-plus-circle"></i>
        </Button>
      )}

      <Table className={style.table} striped>
        <thead>
          {propia ? (
            <tr>
              <th>{isFundsXSystem ? "Funds Custodians" : "Prop Custodians"}</th>
              <th></th>
              <th></th>
              <th colSpan={String(debit)} style={{ color: "red" }}>
                Debit
              </th>
              <th style={{ color: "blue" }}>Credit</th>
              <th></th>
              <th></th>
            </tr>
          ) : (
            <tr>
              <th>Custodians</th>
              <th></th>
              <th></th>
              <th colSpan={String(debit)} style={{ color: "red" }}>
                Debit
              </th>
              <th style={{ color: "blue" }}>Credit</th>
              <th></th>
              <th></th>
            </tr>
          )}
          <tr>
            <th>{translate("Account")}</th>
            {isCashCustodianDifferent && <th>Cash Custody</th>}
            <th>Balance Type</th>
            <th>Portfolio</th>
            {custody == null ? (
              <th></th>
            ) : custody.length == 0 ? (
              <th></th>
            ) : custody[0].Coldebit == 0 ? (
              <th></th>
            ) : (
              custody[0].FootPrintDebit.map((d, j) => (
                // <tr key={`c-${d.EventAccountFootPrintId}`}>
                <th>{`${d.Tooltip}`}</th>
                //  <td>{`${d.Tooltip}`}</td>

                //</tr>
              ))
            )}
            {custody == null ? (
              <th></th>
            ) : custody.length == 0 ? (
              <th></th>
            ) : custody[0].Colcredit == 0 ? (
              <th></th>
            ) : (
              custody[0].FootPrintCredit.map((d, j) => (
                // <tr key={`c-${d.EventAccountFootPrintId}`}>
                <th>{`${d.Tooltip}`}</th>
                //  <td>{`${d.Tooltip}`}</td>

                //</tr>
              ))
            )}
            {!readOnly && <th></th>}
          </tr>
        </thead>
        <tbody>
          {custody == null ? (
            <EmptyTable loading={true} pro={propia} />
          ) : custody.length == 0 ? (
            <EmptyTable pro={propia} />
          ) : (
            custody.map((c, i) => {
              const isCustodyBalanceType = c.EventBalanceType.trim().toLowerCase() === 'custody';
              return (
                <tr key={`c-${i}`}>
                <td style={{ paddingBottom: "20px" }}>
                  <Account
                    AccountId={c.BasicAccountId}
                    AccountName={c.BasicAccountName}
                    AccountNumber={c.BasicAccountId}
                    onChange={(v) => onChange("Account", "Custody", propia, i, 0, v)}
                    filter={[]}
                    hideInstruction={true}
                    hideHolder={true}
                    custody={true}
                    readonly={{
                      AccountName: readOnly,
                    }}
                    errors={
                      {
                        // AccountName: '',
                        // AccountNumber: 0,
                      }
                    }
                    services={{
                      fetchSearchAccount: fetchSearchAccount,
                    }}
                  />
                </td>
                {isCashCustodianDifferent && (
                  <td style={{ paddingBottom: "20px" }}>
                    <Account
                      AccountId={c.EventCashCustAccountId}
                      AccountName={c.EventCashCustAccountName}
                      AccountNumber={c.EventCashCustAccountId}
                      onChange={(v) => onChange("Account", "CustodyCash", propia, i, 0, v)}
                      filter={[]}
                      hideInstruction={true}
                      hideHolder={true}
                      custody={true}
                      readonly={{
                        AccountName: readOnly,
                      }}
                      errors={
                        {
                          // AccountName: '',
                          // AccountNumber: 0,
                        }
                      }
                      services={{
                        fetchSearchAccount: fetchSearchAccount,
                      }}
                    />
                  </td>
                )}

                <td>{c.EventBalanceType}</td>
                <td>
                  <Numeric
                    readOnly={isCustodyBalanceType ? isCustodyBalanceType : readOnly}
                    value={c.EventAccountAmount}
                    onChange={(v) => onChange("EventAccountAmount", "Custody", propia, i, 0, v)}
                    dataTypeDecimalName="currency"
                  />
                </td>
                {c.Coldebit == 0 ? (
                  <div></div>
                ) : (
                  c.FootPrintDebit.map((d, j) => (
                    <td>
                      <Numeric
                        readOnly={ isCustodyBalanceType || d.EventAccountIsTax}
                        style={{ color: "Red" }}
                        value={d.EventAccountDebitCreditVolume}
                        dataTypeDecimalName="currency"
                        onChange={(v) => onChange("Debit", "Custody", propia, i, j, v)}
                      />
                    </td>
                  ))
                )}
                {c.Colcredit == 0 ? (
                  <div></div>
                ) : (
                  c.FootPrintCredit.map((d, j) => (
                    <td>
                      <Numeric
                        readOnly={ isCustodyBalanceType || d.EventAccountIsTax}
                        style={{ color: "Blue" }}
                        value={d.EventAccountDebitCreditVolume}
                        dataTypeDecimalName="currency"
                        onChange={(v) => onChange("Credit", "Custody", propia, i, j, v)}
                      />
                    </td>
                  ))
                )}
                {!readOnly && (
                  <td>
                    <Button
                      outline
                      color="primary"
                      size="sm"
                      onClick={() => removeCustody(custody, propia, "Custody", i, c.BasicAccountId)}
                      className={style.iconBtn}
                    >
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </Button>
                  </td>
                )}
              </tr>
            );
            })
          )}
        </tbody>
      </Table>
    </div>
  );
};

const EmptyTable = ({ loading, pro }) => (
  <tr>
    <td colSpan="10" style={{ textAlign: "center", padding: "60px" }}>
      {loading ? (
        <CircularProgress style={{ marginTop: "10%" }} />
      ) : (
        <div>
          {pro ? (
            <h4 style={{ textAlign: "center" }}>No Prop Custodians</h4>
          ) : (
            <h4 style={{ textAlign: "center" }}>No Custodians</h4>
          )}
        </div>
      )}
    </td>
  </tr>
);

export default Grid;
